var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { createSlice } from '@reduxjs/toolkit';
export var initialState = {
    shown: false,
    title: '',
    body: '',
    dismissButtonText: '',
    dismissButtonVariant: 'solid',
    navigateButtonText: '',
    navigateButtonVariant: 'solid',
    navigateButtonAction: null,
    imageId: null,
    eventId: '',
};
export var bottomSheetSlice = createSlice({
    name: 'bottomSheet',
    initialState: initialState,
    reducers: {
        showBottomSheet: function (state, action) {
            return __assign(__assign(__assign(__assign({}, state), initialState), { shown: true }), action.payload);
        },
        hideBottomSheet: function (state) { return (__assign(__assign({}, state), { shown: false })); },
    },
});
export var showBottomSheet = (_a = bottomSheetSlice.actions, _a.showBottomSheet), hideBottomSheet = _a.hideBottomSheet;
export var selectBottomSheetShown = function (state) {
    return state.bottomSheet.shown;
};
export var selectBottomSheet = function (state) { return state.bottomSheet; };
export var selectBottomSheetEventId = function (state) {
    return state.bottomSheet.eventId;
};
export default bottomSheetSlice.reducer;
